<template>
  <Socialpage />
  <Footer />
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";
import Socialpage from "@/components/notfound/NotFound.vue";

export default {
  components: {
    Footer,
    Socialpage,
  },
};
</script>
